import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { If, Then } from 'react-if';
import { mdiClose } from '@mdi/js';
import ScrollArrow from '../scrollArrow';

import {
  Container,
  Content,
  IconContainer,
  StyledIcon,
  CloseContainer,
  Title,
  HeaderContainer,
  TabsPdfsContainer,
  TabsPdfsItem,
  ContentPdfChildren,
} from './styles';

const Modal = (props) => {
  const [pdfTab, setPdfTab] = useState(0);
  const {
    onCloseRequest,
    children,
    isOpen,
    title,
    itens,
    onClickItens,
    isPdfShowing,
    widthContainer,
    heightContainer,
    overflow,
  } = props;

  if (!isOpen) {
    return <></>;
  }

  return (
    <If condition={isOpen}>
      <Then>
        <Container>
          <Content
            isPdfShowing={isPdfShowing}
            widthContainer={widthContainer}
            heightContainer={heightContainer}
            overflow={overflow}
          >
            <HeaderContainer>
              <Title>{title}</Title>
              <IconContainer onClick={onCloseRequest}>
                <CloseContainer>
                  <StyledIcon size={1.0} icon={mdiClose} color="#9BA8BA" />
                </CloseContainer>
              </IconContainer>
            </HeaderContainer>
            <TabsPdfsContainer id="hscroll">
              {itens && itens.length > 2 && <ScrollArrow />}
              {itens &&
                itens.map((item, index) => (
                  <TabsPdfsItem
                    isEnabled={pdfTab !== index && true}
                    key={item.id}
                    itensQt={itens.length}
                    onClick={() => {
                      onClickItens(item);
                      setPdfTab(index);
                    }}
                  >
                    {item.title}
                  </TabsPdfsItem>
                ))}
            </TabsPdfsContainer>
            {isPdfShowing && (
              <ContentPdfChildren isPdfShowing={isPdfShowing}>
                {children}
              </ContentPdfChildren>
            )}

            {children}
          </Content>
        </Container>
      </Then>
    </If>
  );
};

Modal.defaultProps = {
  isOpen: false,
};

Modal.propTypes = {
  onCloseRequest: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  isOpen: PropTypes.bool,
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  itens: PropTypes.array,
  overflow: PropTypes.string,
  onClickItens: PropTypes.oneOfType([PropTypes.func]),
  isPdfShowing: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.bool,
  ]),
  widthContainer: PropTypes.string,
  heightContainer: PropTypes.string,
};

Modal.defaultProps = {
  title: '',
  itens: null,
  onClickItens: null,
  isPdfShowing: false,
  widthContainer: null,
  heightContainer: null,
  overflow: null,
};

export default Modal;
